import { useState } from 'react';
import Player from 'react-player/file';
import { getInternalPlayer } from 'components/app/_helpers/_app.helper';
import { PlayerFrame, captureFrame } from 'components/app/app-components/frame-generator/frame-generator.helper';

interface Props {
  url: string;
  position?: Seconds;
  cb: (data: PlayerFrame) => void;
}

export const FrameGeneratorVideo = ({ url, position, cb }: Props) => {
  const [player, setPlayer] = useState<Player | null>(null);

  const generator = (player: Player) => {
    const elem = getInternalPlayer(player)!;
    cb(captureFrame(elem, elem.videoWidth, elem.videoHeight));
  };

  const onReady = () => {
    if (!player) return;
    if (!position) generator(player);
    else player.seekTo(position, 'seconds');
  };

  const onSeek = () => {
    if (!player) return;
    generator(player);
  };

  return (
    <div>
      <Player
        onSeek={onSeek}
        onReady={onReady}
        ref={(player) => setPlayer(player)}
        config={{ attributes: { controls: false, crossOrigin: 'anonymous' } }}
        url={url}
        height="100%"
        width="100%"
      />
    </div>
  );
};
